var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Link, LinkIconPositions, LinkUnderlineOptions } from '../../../../atoms/link';
var BTS = function (_a) {
    var label = _a.label, linkUrl = _a.linkUrl;
    var linkConfig = {
        linkUrl: linkUrl,
        label: label,
        icon: 'pmi-icon-arrowleft',
        iconPosition: LinkIconPositions.Left,
        underline: LinkUnderlineOptions.Hover,
        fullWidth: false
    };
    return React.createElement(Link, __assign({}, linkConfig));
};
export { BTS as BackToShop };
